import Icon from '../components/Icon.vue'

Icon.register({"dollar-sign":{"width":288,"height":512,"paths":[{"d":"M209.2 233.4L101.2 201.8C88.7 198.2 80 186.5 80 173.5 80 157.2 93.2 144 109.5 144H175.8C188 144 200 147.7 210 154.5 216.1 158.6 224.3 157.6 229.5 152.5L264.3 118.5C271.4 111.6 270.4 100.1 262.5 94 238 74.8 207.4 64.1 176 64V16C176 7.2 168.8 0 160 0H128C119.2 0 112 7.2 112 16V64H109.5C45.8 64-5.4 118.7 0.5 183.6 4.7 229.7 39.9 267.2 84.3 280.2L186.8 310.2C199.3 313.9 208 325.5 208 338.5 208 354.8 194.8 368 178.5 368H112.2C100 368 88 364.3 78 357.5 71.9 353.4 63.7 354.4 58.5 359.5L23.7 393.5C16.6 400.4 17.6 411.9 25.5 418 50 437.2 80.6 447.9 112 448V496C112 504.8 119.2 512 128 512H160C168.8 512 176 504.8 176 496V447.8C222.6 446.9 266.3 419.2 281.7 375.1 303.2 313.5 267.1 250.3 209.2 233.4z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/dollar-sign.js
// module id = null
// module chunks = 